import src from '../assets/swing365.png';
import { imageLogo } from './imageLogo';

/**
 * Swing 365 — teal wordmark lockup, whitespace-trimmed.
 */
export const Swing365Logo = imageLogo({
  src,
  width: 918,
  height: 217,
  alt: 'Swing 365',
});
